import script from "./FilterDescription.vue?vue&type=script&setup=true&lang=js"
export * from "./FilterDescription.vue?vue&type=script&setup=true&lang=js"

import "./FilterDescription.vue?vue&type=style&index=0&id=4086d16f&lang=scss"

const __exports__ = script;

export default __exports__